// Constants
const ANCHOR_TIMESTAMP_FLARE = 1682611200; // in seconds
const ANCHOR_TIMESTAMP_SONGBIRD = 1682611200; // in seconds
const VOTING_ROUND_DURATION = 90; // in seconds

// Time calculation helpers
export const getExpectedEndTime = (roundId, network) => {
  let anchorTimestamp;
  if (network.toLowerCase() === 'flare') {
    anchorTimestamp = ANCHOR_TIMESTAMP_FLARE;
  } else if (network.toLowerCase() === 'songbird') {
    anchorTimestamp = ANCHOR_TIMESTAMP_SONGBIRD;
  } else {
    anchorTimestamp = ANCHOR_TIMESTAMP_FLARE; // default to flare
  }

  const expectedEndTimeSeconds = anchorTimestamp + roundId * VOTING_ROUND_DURATION;
  return expectedEndTimeSeconds * 1000; // convert to milliseconds
};

// Status evaluation helpers
export const getHeaderStatus = (entityData) => {
  if (!entityData) return 'red';

  const toNum = (v) => {
    const n = v === undefined || v === null ? NaN : Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  const sixHourValues = [
    toNum(entityData?.submit1?.['6hr']?.percentage),
    toNum(entityData?.submit2?.['6hr']?.percentage),
    toNum(entityData?.submitSignatures?.['6hr']?.percentage),
  ];

  if (sixHourValues.some((value) => value === 100)) {
    return 'green';
  } else if (sixHourValues.some((value) => value >= 95)) {
    return 'amber';
  } else {
    return 'red';
  }
};

// CSS class helpers
export const getHeaderClass = (status) => {
  switch (status) {
    case 'green':
      return 'bg-green';
    case 'amber':
      return 'bg-amber';
    case 'red':
    default:
      return 'bg-red';
  }
};

export const getPercentageClass = (percentage) => {
  if (percentage >= 99.9) return 'color-green';
  if (percentage >= 97) return 'color-red';
  return 'color-red';
};

export const getCountClass = (count) => {
  if (count === 0) return 'color-green';
  if (count <= 2) return 'color-amber';
  return 'color-red';
};

export const getMetricClass = (value, total) => {
  const percentage = (value / total) * 100;
  return percentage <= 1
    ? 'color-green'
    : percentage <= 3
    ? 'color-amber'
    : 'color-red';
};

// Asset/Icon helpers
export const getHeaderIcon = (status) => {
  return status === 'green'
    ? 'https://cdn.prod.website-files.com/64eb6710f68f6b333f8886a6/671760d711a4e1bbe2b0489d_tick-circle%20(1).svg'
    : 'https://cdn.prod.website-files.com/64eb6710f68f6b333f8886a6/671760d7912d60d1ebb42595_info-circle%20(1).svg';
};

// Calculation helpers
export const calculateSubmissionsAverage = (entityData) => {
  if (!entityData) return 0;

  const toNum = (v) => {
    const n = v === undefined || v === null ? NaN : Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  const sixHourValues = [
    toNum(entityData?.submit1?.['6hr']?.percentage),
    toNum(entityData?.submit2?.['6hr']?.percentage),
    toNum(entityData?.submitSignatures?.['6hr']?.percentage),
  ];

  return Math.round(
    sixHourValues.reduce((sum, value) => sum + value, 0) / sixHourValues.length
  );
};

export const calculateResultsIssues = (metricsData) => {
  if (!metricsData) return 0;

  const sixHourMetrics = metricsData?.['6hr'] || {};
  // Support both legacy and new field names
  const late = sixHourMetrics.late_rounds ?? sixHourMetrics.late ?? 0;
  const missing = sixHourMetrics.missing_rounds ?? sixHourMetrics.missing ?? 0;
  const invalid = sixHourMetrics.invalid_rounds ?? sixHourMetrics.invalid ?? 0;
  return (late || 0) + (missing || 0) + (invalid || 0);
};

export const getIssuesColor = (issues) => {
  if (issues === 0) return 'color-green';
  if (issues <= 2) return 'color-amber';
  return 'color-red';
};

// FDC-specific helpers
export const calculateFDCAverage = (entityData) => {
  if (!entityData) return 0;

  const sixHourValue = entityData?.fdc_submissions?.['6hr']?.percentage || 0;
  return Math.round(sixHourValue);
};

export const getFDCIssuesColor = (validPercentage) => {
  if (validPercentage >= 95) return 'color-green';
  if (validPercentage >= 85) return 'color-amber';
  return 'color-red';
};